// import React, { Fragment, useEffect, useState, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import { Container, Row, Col, Button, Modal } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
// import LazyLoad from "react-lazyload";

// import CollectionInnerPageAboutImg1 from "../../assets/img/collection-inner/collection-inner-about-img-1.png";
// import CollectionInnerPageAboutImg2 from "../../assets/img/collection-inner/collection-inner-about-img-2.png";
// import ReCAPTCHA from "react-google-recaptcha";

// import marquisLogo from "../../assets/marquis-logo.svg";
// import * as apiUrl from "../../apiUrl";

// // Country code map
// const countryCodeMap = {
//   IN: "+91", // India
//   AF: "+93", // Afghanistan
//   AL: "+355", // Albania
//   DZ: "+213", // Algeria
//   AS: "+1-684", // American Samoa
//   AD: "+376", // Andorra
//   AO: "+244", // Angola
//   AI: "+1-264", // Anguilla
//   AG: "+1-268", // Antigua and Barbuda
//   AR: "+54", // Argentina
//   AM: "+374", // Armenia
//   AW: "+297", // Aruba
//   AU: "+61", // Australia
//   AT: "+43", // Austria
//   AZ: "+994", // Azerbaijan
//   BS: "+1-242", // Bahamas
//   BH: "+973", // Bahrain
//   BD: "+880", // Bangladesh
//   BB: "+1-246", // Barbados
//   BY: "+375", // Belarus
//   BE: "+32", // Belgium
//   BZ: "+501", // Belize
//   BJ: "+229", // Benin
//   BT: "+975", // Bhutan
//   BO: "+591", // Bolivia
//   BA: "+387", // Bosnia and Herzegovina
//   BW: "+267", // Botswana
//   BR: "+55", // Brazil
//   IO: "+246", // British Indian Ocean Territory
//   VG: "+1-284", // British Virgin Islands
//   BN: "+673", // Brunei
//   BG: "+359", // Bulgaria
//   BF: "+226", // Burkina Faso
//   BI: "+257", // Burundi
//   KH: "+855", // Cambodia
//   CM: "+237", // Cameroon
//   CA: "+1", // Canada
//   CV: "+238", // Cape Verde
//   KY: "+1-345", // Cayman Islands
//   CF: "+236", // Central African Republic
//   TD: "+235", // Chad
//   CL: "+56", // Chile
//   CN: "+86", // China
//   CX: "+61", // Christmas Island
//   CC: "+61", // Cocos (Keeling) Islands
//   CO: "+57", // Colombia
//   KM: "+269", // Comoros
//   CG: "+242", // Congo
//   CD: "+243", // Congo, Democratic Republic of the
//   CK: "+682", // Cook Islands
//   CR: "+506", // Costa Rica
//   CI: "+225", // Côte d'Ivoire
//   HR: "+385", // Croatia
//   CU: "+53", // Cuba
//   CW: "+599", // Curaçao
//   CY: "+357", // Cyprus
//   CZ: "+420", // Czech Republic
//   DK: "+45", // Denmark
//   DJ: "+253", // Djibouti
//   DM: "+1-767", // Dominica
//   DO: "+1-809", // Dominican Republic
//   EC: "+593", // Ecuador
//   EG: "+20", // Egypt
//   SV: "+503", // El Salvador
//   GQ: "+240", // Equatorial Guinea
//   ER: "+291", // Eritrea
//   EE: "+372", // Estonia
//   ET: "+251", // Ethiopia
//   FK: "+500", // Falkland Islands
//   FO: "+298", // Faroe Islands
//   FJ: "+679", // Fiji
//   FI: "+358", // Finland
//   FR: "+33", // France
//   GF: "+594", // French Guiana
//   PF: "+689", // French Polynesia
//   TF: "+262", // French Southern Territories
//   GA: "+241", // Gabon
//   GM: "+220", // Gambia
//   GE: "+995", // Georgia
//   DE: "+49", // Germany
//   GH: "+233", // Ghana
//   GI: "+350", // Gibraltar
//   GR: "+30", // Greece
//   GL: "+299", // Greenland
//   GD: "+1-473", // Grenada
//   GP: "+590", // Guadeloupe
//   GU: "+1-671", // Guam
//   GT: "+502", // Guatemala
//   GG: "+44-1481", // Guernsey
//   GN: "+224", // Guinea
//   GW: "+245", // Guinea-Bissau
//   GY: "+592", // Guyana
//   HT: "+509", // Haiti
//   HM: "+672", // Heard Island and McDonald Islands
//   VA: "+379", // Holy See
//   HN: "+504", // Honduras
//   HK: "+852", // Hong Kong
//   HU: "+36", // Hungary
//   IS: "+354", // Iceland
//   ID: "+62", // Indonesia
//   IR: "+98", // Iran
//   IQ: "+964", // Iraq
//   IE: "+353", // Ireland
//   IM: "+44-1624", // Isle of Man
//   IL: "+972", // Israel
//   IT: "+39", // Italy
//   JE: "+44-1534", // Jersey
//   JO: "+962", // Jordan
//   KZ: "+7", // Kazakhstan
//   KE: "+254", // Kenya
//   KI: "+686", // Kiribati
//   KP: "+850", // Korea, North
//   KR: "+82", // Korea, South
//   KW: "+965", // Kuwait
//   KG: "+996", // Kyrgyzstan
//   LA: "+856", // Laos
//   LV: "+371", // Latvia
//   LB: "+961", // Lebanon
//   LS: "+266", // Lesotho
//   LR: "+231", // Liberia
//   LY: "+218", // Libya
//   LI: "+423", // Liechtenstein
//   LT: "+370", // Lithuania
//   LU: "+352", // Luxembourg
//   MO: "+853", // Macao
//   MK: "+389", // Macedonia
//   MG: "+261", // Madagascar
//   MW: "+265", // Malawi
//   MY: "+60", // Malaysia
//   MV: "+960", // Maldives
//   ML: "+223", // Mali
//   MT: "+356", // Malta
//   MH: "+692", // Marshall Islands
//   MQ: "+596", // Martinique
//   MR: "+222", // Mauritania
//   MU: "+230", // Mauritius
//   YT: "+262", // Mayotte
//   MX: "+52", // Mexico
//   FM: "+691", // Micronesia
//   MD: "+373", // Moldova
//   MC: "+377", // Monaco
//   MN: "+976", // Mongolia
//   MS: "+1-664", // Montserrat
//   MA: "+212", // Morocco
//   MZ: "+258", // Mozambique
//   MM: "+95", // Myanmar
//   NA: "+264", // Namibia
//   NR: "+674", // Nauru
//   NP: "+977", // Nepal
//   NL: "+31", // Netherlands
//   NC: "+687", // New Caledonia
//   NZ: "+64", // New Zealand
//   NI: "+505", // Nicaragua
//   NE: "+227", // Niger
//   NG: "+234", // Nigeria
//   NU: "+683", // Niue
//   NF: "+672", // Norfolk Island
//   MP: "+1-670", // Northern Mariana Islands
//   NO: "+47", // Norway
//   OM: "+968", // Oman
//   PK: "+92", // Pakistan
//   PW: "+680", // Palau
//   PA: "+507", // Panama
//   PG: "+675", // Papua New Guinea
//   PY: "+595", // Paraguay
//   PE: "+51", // Peru
//   PH: "+63", // Philippines
//   PN: "+870", // Pitcairn Islands
//   PL: "+48", // Poland
//   PT: "+351", // Portugal
//   PR: "+1-787", // Puerto Rico
//   QA: "+974", // Qatar
//   RE: "+262", // Réunion
//   RO: "+40", // Romania
//   RU: "+7", // Russia
//   RW: "+250", // Rwanda
//   BL: "+590", // Saint Barthélemy
//   SH: "+290", // Saint Helena
//   KN: "+1-869", // Saint Kitts and Nevis
//   LC: "+1-758", // Saint Lucia
//   MF: "+590", // Saint Martin
//   VC: "+1-784", // Saint Vincent and the Grenadines
//   WS: "+685", // Samoa
//   SM: "+378", // San Marino
//   ST: "+239", // São Tomé and Príncipe
//   SA: "+966", // Saudi Arabia
//   SN: "+221", // Senegal
//   RS: "+381", // Serbia
//   SC: "+248", // Seychelles
//   SL: "+232", // Sierra Leone
//   SG: "+65", // Singapore
//   SX: "+1-721", // Sint Maarten
//   SK: "+421", // Slovakia
//   SI: "+386", // Slovenia
//   SB: "+677", // Solomon Islands
//   SO: "+252", // Somalia
//   ZA: "+27", // South Africa
//   GS: "+500", // South Georgia and the South Sandwich Islands
//   SS: "+211", // South Sudan
//   ES: "+34", // Spain
//   LK: "+94", // Sri Lanka
//   SD: "+249", // Sudan
//   SR: "+597", // Suriname
//   SZ: "+268", // Swaziland
//   SE: "+46", // Sweden
//   CH: "+41", // Switzerland
//   SY: "+963", // Syria
//   TW: "+886", // Taiwan
//   TJ: "+992", // Tajikistan
//   TZ: "+255", // Tanzania
//   TH: "+66", // Thailand
//   TL: "+670", // Timor-Leste
//   TG: "+228", // Togo
//   TK: "+690", // Tokelau
//   TO: "+676", // Tonga
//   TT: "+1-868", // Trinidad and Tobago
//   TN: "+216", // Tunisia
//   TR: "+90", // Turkey
//   TM: "+993", // Turkmenistan
//   TC: "+1-649", // Turks and Caicos Islands
//   TV: "+688", // Tuvalu
//   UG: "+256", // Uganda
//   UA: "+380", // Ukraine
//   AE: "+971", // United Arab Emirates
//   GB: "+44", // United Kingdom
//   US: "+1", // United States
//   UY: "+598", // Uruguay
//   UZ: "+998", // Uzbekistan
//   VU: "+678", // Vanuatu
//   VE: "+58", // Venezuela
//   VN: "+84", // Vietnam
//   VG: "+1-284", // Virgin Islands (British)
//   VI: "+1-340", // Virgin Islands (US)
//   WF: "+681", // Wallis and Futuna
//   EH: "+212", // Western Sahara
//   YE: "+967", // Yemen
//   ZM: "+260", // Zambia
//   ZW: "+263", // Zimbabwe
// };

// function CollectionInnerAbout({
//   title,
//   subTitle,
//   description,
//   leftImage,
//   rightImage,
//   brochure,
// }) {
//   const [show, setShow] = useState(false);

//   const [aboutLogo, setaboutLogo] = useState(null);

//   const location = useLocation();

//   const handleClosebrochure = () => setShow(false);
//   const handleShowbrochure = () => setShow(true);

//   const [showThankYouModal, setShowThankYouModal] = useState(false);
//   const handleCloseThankYouModal = () => {
//     setShowThankYouModal(false);
//     setThankYouMessage("");
//   };

//   const [thankYouMessage, setThankYouMessage] = useState("");

//   const [captchaToken, setCaptchaToken] = useState(null);
//   const [errors, setErrors] = useState({});
//   const captchaRef = useRef(null);

//   const [formData, setFormData] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     countryCode: "+XX",
//     property: "",
//   });

//   const handleSuccess = (position) => {
//     const { latitude, longitude } = position.coords;

//     // Fetch country code using an IP-based geolocation service
//     fetch("https://ipinfo.io/json?token=b45ae1fedc21cb")
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch country code");
//         }
//         return response.json();
//       })
//       .then((data) => {
//         const countryCode = data.country; // Country short name (e.g., "IN")
//         // console.log("Country code from IP geolocation:", countryCode);

//         // Lookup the country calling code from the countryCodeMap
//         const countryCallingCode = countryCodeMap[countryCode] || "+XX"; // Default to +XX if not found
//         // console.log("Country calling code:", countryCallingCode);

//         // Update state with the country calling code
//         setFormData((prev) => ({
//           ...prev,
//           countryCode: countryCallingCode,
//         }));
//       })
//       .catch((error) => {
//         console.error("Error fetching country code:", error.message);
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           location: "Error fetching country code: " + error.message,
//         }));
//       });
//   };

//   // Geolocation error handler
//   const handleError = (error) => {
//     switch (error.code) {
//       case error.PERMISSION_DENIED:
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           location: "Permission denied. Please allow location access.",
//         }));
//         break;
//       case error.POSITION_UNAVAILABLE:
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           location: "Position unavailable. Please try again later.",
//         }));
//         break;
//       case error.TIMEOUT:
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           location: "Location request timed out. Please try again.",
//         }));
//         break;
//       default:
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           location: "An unknown error occurred.",
//         }));
//         break;
//     }

//     // Fallback to IP-based geolocation if geolocation fails
//     fetch("https://ipinfo.io/json?token=b45ae1fedc21cb")
//       .then((response) => response.json())
//       .then((data) => {
//         const countryCode = data.country;
//         setFormData((prev) => ({
//           ...prev,
//           countryCode: countryCode || "+XX",
//         }));
//       })
//       .catch((error) => {
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           location: "Error fetching country code: " + error.message,
//         }));
//       });
//   };

//   useEffect(() => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
//     } else {
//       setErrors((prevErrors) => ({
//         ...prevErrors,
//         location: "Geolocation is not supported by this browser.",
//       }));
//     }
//   }, []);

//   const handlePaste = (event) => {
//     event.preventDefault();
//     const clipboardData = event.clipboardData || window.clipboardData;
//     const pastedText = clipboardData.getData("text");

//     // Check if pasted text contains only numbers
//     if (/^\d+$/.test(pastedText)) {
//       this.setState({ phone: pastedText });
//     }
//   };

//   const validateField = (fieldName, value) => {
//     const namePattern = /^[A-Za-z\s]+$/;
//     const mobilePattern = /^[0-9]+$/;
//     let error = "";

//     switch (fieldName) {
//       case "name":
//         if (!value) error = "Please enter your Name.";
//         else if (!namePattern.test(value))
//           error = "Name should only contain letters.";
//         break;

//       case "email":
//         if (!value) error = "Please enter your Email.";
//         else if (!/\S+@\S+\.\S+/.test(value)) error = "Email is invalid.";
//         break;

//       case "mobile":
//         if (!value) error = "Please enter your Mobile Number.";
//         else if (!mobilePattern.test(value) || value.length < 10)
//           error =
//             "Mobile Number should only contain numbers and be at least 10 digits.";
//         break;

//       case "countryCode":
//         if (!value) error = "Please Select Contry Code";
//         break;

//       case "captchaToken":
//         if (!value) error = "Please Select the CAPTCHA.";
//         break;

//       default:
//         break;
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
//   };

//   const handleBlur = (e) => {
//     const { name, value } = e.target;
//     validateField(name, value);
//   };

//   const handleCaptchaChange = (token) => {
//     setCaptchaToken(token);
//   };

//   const handleNameChange = (e) => {
//     const { name, value } = e.target;
//     const namePattern = /^[A-Za-z\s]*$/;

//     if (namePattern.test(value)) {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleMobileChange = (e) => {
//     const { value } = e.target;
//     const mobilePattern = /^[0-9]*$/;

//     if (mobilePattern.test(value)) {
//       setFormData((prev) => ({ ...prev, mobile: value }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate all fields before submitting
//     // Object.keys(formData).forEach((key) => {
//     //   validateField(key, formData[key]);
//     // });

//     // validateField("captchaToken", formData.captchaToken);

//     // // Check if there are any errors or if CAPTCHA is missing
//     // if (
//     //   Object.values(errors).some((error) => error) ||
//     //   !formData.captchaToken
//     // ) {
//     //   setErrors((prev) => ({
//     //     ...prev,
//     //     captchaToken: "Please Select the CAPTCHA.",
//     //   }));
//     //   return;
//     // }

//     // Validate all fields
//     let isValid = true;
//     Object.keys(formData).forEach((key) => {
//       validateField(key, formData[key]);
//       if (errors[key]) {
//         isValid = false;
//       }
//     });

//     // Validate reCAPTCHA last
//     if (!formData.captchaToken) {
//       setErrors((prev) => ({
//         ...prev,
//         captchaToken: "Please Select the CAPTCHA.",
//       }));
//       isValid = false;
//     }

//     if (!isValid) return;

//     // Proceed to backend validation
//     try {
//       const formDataObj = new FormData();
//       formDataObj.append("name", formData.name);
//       formDataObj.append("mobile", formData.mobile);
//       formDataObj.append("email", formData.email);
//       formDataObj.append("countryCode", formData.countryCode);
//       formDataObj.append("property", title);
//       formDataObj.append("captchaToken", formData.captchaToken);
//       formDataObj.append("brochure", brochure);

//       // Send form data to backend for validation
//       const response = await fetch(apiUrl.apiUrl + `/api/brochure/submit`, {
//         method: "POST",
//         body: formDataObj,
//       });

//       const result = await response.json();

//       console.log(result);

//       if (result.success) {
//         if (result.verified) {
//           setThankYouMessage("Your brochure is ready to download!");
//           setShowThankYouModal(true);
//           setTimeout(() => triggerDownload(), 1500);
//         } else {
//           setThankYouMessage(
//             "Please check your email to verify before downloading.",
//           );
//           setShowThankYouModal(true);
//         }

//         // Reset form and show modal on success
//         setFormData({
//           name: "",
//           mobile: "",
//           email: "",
//           countryCode: "",
//           property: "",
//           captchaToken: "",
//         });

//         // Reset CAPTCHA
//         if (captchaRef.current) {
//           captchaRef.current.reset();
//         }

//         setCaptchaToken(null);
//         localStorage.removeItem("captchaToken");

//         // // Show the modal or success message
//         // setShowThankYouModal(true);
//         // setThankYouMessage(
//         //   "Please check your email to verify before downloading."
//         // );

//         // // Trigger the download function after backend validation
//         // triggerDownload();
//       } else {
//         // Handle backend validation failure
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           server: "There was an issue with the submission. Please try again.",
//         }));
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//     }
//   };

//   const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const triggerDownload = () => {
//     if (!brochure) return;

//     const link = document.createElement("a");
//     link.href = `${apiUrl.apiUrl}/${brochure}`; // use the prop
//     link.setAttribute("download", "brochure.pdf");
//     link.setAttribute("target", "_blank");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   useEffect(() => {
//     const fetchLogos = async () => {
//       try {
//         const logoresponse = await fetch(apiUrl.apiUrl + `/api/logos/section`);
//         if (!logoresponse.ok) throw new Error("Failed to fetch logo data");
//         const logodata = await logoresponse.json();

//         const logoPathMap = {
//           "": "",
//           "/properties/marquis-horizon": "Marquis Horizon",
//           "/properties/marquis-one": "Marquis One",
//           "/properties/marquis-vista": "Marquis Vista",
//           "/properties/marquis-insignia": "Marquis Insignia",
//           "/properties/marquis-elegance": "Marquis Elegance",
//           "/properties/marquis-galleria": "Marquis Galleria",
//           "/properties/marquis-signature": "Marquis Signature",
//           "/properties/2020-marquis": "2020 Marquis",
//         };
//         const pageTitle = logoPathMap[location.pathname] || "Header Logo";
//         const selectedLogo = logodata.find(
//           (logo) => logo.logo_title === pageTitle,
//         );
//         setaboutLogo(selectedLogo);
//       } catch (error) {
//         console.error("Error fetching logo data:", error);
//       }
//     };
//     fetchLogos();
//   }, [location.pathname]);

//   return (
//     <Fragment>
//       <section className="collection-inner-page-about-sec">
//         <Container fluid>
//           <Row className="banner-text-center">
//             <Col md={6}>
//               <div className="heading-div">
//                 {aboutLogo && (
//                   <img
//                     src={apiUrl.apiUrl + `/${aboutLogo.logo}`}
//                     className="img-fluid collection-logo" data-aos="fade-up"
//                   />
//                 )}
//                 <h1 className="common-head darkGrey" data-aos="fade-up">
//                   {title}
//                 </h1>                
//               </div>
//             </Col>
//           </Row>
//         </Container>
//         <Container fluid className="collection-inner-page-about-container">
//           <Row>
//             <Col md={6}>
//               {/* <LazyLoad> */}
//               <img
//                 src={`${apiUrl.apiUrl}/${leftImage}`}
//                 className="img-fluid"
//                 alt={title}
//                 data-aos="fade-down"
//               />
//               {/* </LazyLoad> */}
//             </Col>
//             <Col md={6}>
//               {/* <LazyLoad> */}
//               <img
//                 src={`${apiUrl.apiUrl}/${rightImage}`}
//                 className="img-fluid col-new-img"
//                 alt="Apartments for sale in Dubai"
//                 data-aos="fade-down"
//               />
//               {/* </LazyLoad> */}
//               <div className="content-div">
//                 <h2 className="common-head goldenColor">{subTitle}</h2>
//                 <p className="common-para">{description}</p>
//                 <div
//                   onClick={handleShowbrochure}
//                   className="marquis-grey-button"
//                 >
//                   Download brochure
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>

//       {/* Enquiry Button Modal */}
//       <div>
//         {/* Enquiry Button Modal */}
//         <Modal
//           show={show}
//           onHide={handleClosebrochure}
//           centered
//           size="lg"
//           className="download-brochure-modal"
//         >
//           <Modal.Header closeButton></Modal.Header>

//           <Modal.Body>
//             <div className="enquiry-form-modal-div">
//               <Container fluid>
//                 <Row className="flex-center career-inner-desc-row">
//                   <Col md={12}>
//                     <div className="career-inner-form-div">
//                       <h2 className="common-head goldenColor">
//                         Download Brochure
//                       </h2>
//                       <Form onSubmit={handleSubmit}>
//                         <Row>
//                           <Form.Group
//                             className="col-md-12 mb-3"
//                             controlId="exampleForm.ControlInput1"
//                           >
//                             <Form.Control
//                               type="text"
//                               name="name"
//                               placeholder="Your Name *"
//                               value={formData.name}
//                               onChange={handleNameChange}
//                               onBlur={handleBlur}
//                             />

//                             {errors.name && (
//                               <p className="error">{errors.name}</p>
//                             )}
//                           </Form.Group>
//                           <Form.Group
//                             className="col-md-12 mb-3"
//                             controlId="exampleForm.ControlInput1"
//                           >
//                             <Form.Control
//                               type="text"
//                               name="email"
//                               placeholder="Email"
//                               value={formData.email}
//                               onChange={handleChange}
//                               onBlur={handleBlur}
//                             />
//                             {errors.email && (
//                               <p className="error">{errors.email}</p>
//                             )}
//                           </Form.Group>
//                         </Row>
//                         <Row>
//                           <Form.Group
//                             className="col-md-12 mb-3"
//                             controlId="exampleForm.ControlInput1"
//                           >
//                             <div style={{ display: "flex" }}>
//                               <Form.Control
//                                 className="custom-form-control"
//                                 type="text"
//                                 placeholder={
//                                   formData.countryCode
//                                     ? `${formData.countryCode} `
//                                     : "+XX "
//                                 }
//                                 value={formData.countryCode}
//                                 onBlur={handleBlur}
//                               />
//                               <Form.Control
//                                 type="text"
//                                 onPaste={handlePaste}
//                                 name="mobile"
//                                 placeholder="Your Phone Number *"
//                                 value={formData.mobile}
//                                 onChange={handleMobileChange}
//                                 onBlur={handleBlur}
//                               />
//                             </div>

//                             <div style={{ display: "flex" }}>
//                               {errors.countryCode && (
//                                 <p className="error">{errors.countryCode}</p>
//                               )}

//                               {errors.mobile && (
//                                 <p className="error">{errors.mobile}</p>
//                               )}
//                             </div>
//                           </Form.Group>
//                         </Row>
//                         <Row>
//                           <Form.Group className="col-md-12 mb-3">
//                             <ReCAPTCHA
//                               className="gcaptcha-size"
//                               sitekey="6LeGM28qAAAAAGmZjltF8c4tuHV9F9vxFdjtKPoC"
//                               ref={captchaRef}
//                               onChange={(value) => {
//                                 setFormData((prevData) => ({
//                                   ...prevData,
//                                   captchaToken: value,
//                                 }));
//                                 validateField("captchaToken", value);
//                               }}
//                             />

//                             {errors.captchaToken && (
//                               <p className="error gcaptcha-error-msg">
//                                 {errors.captchaToken}
//                               </p>
//                             )}
//                           </Form.Group>
//                         </Row>

//                         <Row className="mt-2 form-btn">
//                           <Col md={12}>
//                             <button
//                               type="submit"
//                               className="marquis-grey-button"
//                             >
//                               Submit
//                             </button>
//                           </Col>
//                         </Row>
//                       </Form>
//                     </div>
//                     <Row className="mt-2 form-btn">
//                       <Col md={12}>
//                         <div className="enquiry-form-bottom-logo">
//                           <img
//                             className="img-fluid"
//                             src={marquisLogo}
//                             alt="marquislogo-img"
//                           />
//                         </div>
//                       </Col>
//                     </Row>
//                   </Col>
//                 </Row>
//               </Container>
//             </div>
//           </Modal.Body>
//         </Modal>
//       </div>

//       {/* Modal Component */}
//       <Modal
//         show={showThankYouModal}
//         onHide={handleCloseThankYouModal}
//         className="response-popup"
//       >
//         <Modal.Header>
//           <Modal.Title>Thank You!</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>{thankYouMessage}</Modal.Body>
//         <Modal.Footer>
//           <button
//             className="marquis-grey-button"
//             onClick={handleCloseThankYouModal}
//           >
//             Close
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </Fragment>
//   );
// }

// export default CollectionInnerAbout;


import React, { Fragment, useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import LazyLoad from "react-lazyload";

import CollectionInnerPageAboutImg1 from "../../assets/img/collection-inner/collection-inner-about-img-1.png";
import CollectionInnerPageAboutImg2 from "../../assets/img/collection-inner/collection-inner-about-img-2.png";
import ReCAPTCHA from "react-google-recaptcha";

import marquisLogo from "../../assets/marquis-logo.svg";
import * as apiUrl from "../../apiUrl";

import useCountryCode from "../../hooks/useCountryCode";
import CountryCodeField from "../common/CountryCodeField";

function CollectionInnerAbout({
  title,
  subTitle,
  description,
  leftImage,
  rightImage,
  brochure,
}) {
  const [show, setShow] = useState(false);

  const [aboutLogo, setaboutLogo] = useState(null);

  const location = useLocation();

  const handleClosebrochure = () => setShow(false);
  const handleShowbrochure = () => setShow(true);

  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const handleCloseThankYouModal = () => {
    setShowThankYouModal(false);
    setThankYouMessage("");
  };

  const [thankYouMessage, setThankYouMessage] = useState("");

  const [captchaToken, setCaptchaToken] = useState(null);
  const [errors, setErrors] = useState({});
  const captchaRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    countryCode: "+XX",
    property: "",
  });

  // Asks for geolocation permission on page load, falls back to an IP
  // lookup either way, and resolves the visitor's dial code — so the
  // "Country Code" field below is already filled in by the time they open
  // this form.
  const { countryCode, setCountryCode, permissionGranted, locationError } =
    useCountryCode();

  useEffect(() => {
    setFormData((prev) => ({ ...prev, countryCode }));
  }, [countryCode]);

  useEffect(() => {
    if (locationError) {
      setErrors((prevErrors) => ({ ...prevErrors, location: locationError }));
    }
  }, [locationError]);

  const handleCountryCodeSelect = (e) => {
    setCountryCode(e.target.value);
    validateField("countryCode", e.target.value);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text");

    // Check if pasted text contains only numbers
    if (/^\d+$/.test(pastedText)) {
      setFormData((prev) => ({ ...prev, mobile: pastedText }));
    }
  };

  const validateField = (fieldName, value) => {
    const namePattern = /^[A-Za-z\s]+$/;
    const mobilePattern = /^[0-9]+$/;
    let error = "";

    switch (fieldName) {
      case "name":
        if (!value) error = "Please enter your Name.";
        else if (!namePattern.test(value))
          error = "Name should only contain letters.";
        break;

      case "email":
        if (!value) error = "Please enter your Email.";
        else if (!/\S+@\S+\.\S+/.test(value)) error = "Email is invalid.";
        break;

      case "mobile":
        if (!value) error = "Please enter your Mobile Number.";
        else if (!mobilePattern.test(value) || value.length < 10)
          error =
            "Mobile Number should only contain numbers and be at least 10 digits.";
        break;

      case "countryCode":
        if (!value) error = "Please Select Contry Code";
        break;

      case "captchaToken":
        if (!value) error = "Please Select the CAPTCHA.";
        break;

      default:
        break;
    }

    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    const namePattern = /^[A-Za-z\s]*$/;

    if (namePattern.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleMobileChange = (e) => {
    const { value } = e.target;
    const mobilePattern = /^[0-9]*$/;

    if (mobilePattern.test(value)) {
      setFormData((prev) => ({ ...prev, mobile: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    let isValid = true;
    Object.keys(formData).forEach((key) => {
      validateField(key, formData[key]);
      if (errors[key]) {
        isValid = false;
      }
    });

    // Validate reCAPTCHA last
    if (!formData.captchaToken) {
      setErrors((prev) => ({
        ...prev,
        captchaToken: "Please Select the CAPTCHA.",
      }));
      isValid = false;
    }

    if (!isValid) return;

    // Proceed to backend validation
    try {
      const formDataObj = new FormData();
      formDataObj.append("name", formData.name);
      formDataObj.append("mobile", formData.mobile);
      formDataObj.append("email", formData.email);
      formDataObj.append("countryCode", formData.countryCode);
      formDataObj.append("property", title);
      formDataObj.append("captchaToken", formData.captchaToken);
      formDataObj.append("brochure", brochure);

      // Send form data to backend for validation
      const response = await fetch(apiUrl.apiUrl + `/api/brochure/submit`, {
        method: "POST",
        body: formDataObj,
      });

      const result = await response.json();

      console.log(result);

      if (result.success) {
        if (result.verified) {
          setThankYouMessage("Your brochure is ready to download!");
          setShowThankYouModal(true);
          setTimeout(() => triggerDownload(), 1500);
        } else {
          setThankYouMessage(
            "Please check your email to verify before downloading.",
          );
          setShowThankYouModal(true);
        }

        // Reset form and show modal on success
        setFormData({
          name: "",
          mobile: "",
          email: "",
          countryCode,
          property: "",
          captchaToken: "",
        });

        // Reset CAPTCHA
        if (captchaRef.current) {
          captchaRef.current.reset();
        }

        setCaptchaToken(null);
        localStorage.removeItem("captchaToken");
      } else {
        // Handle backend validation failure
        setErrors((prevErrors) => ({
          ...prevErrors,
          server: "There was an issue with the submission. Please try again.",
        }));
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const triggerDownload = () => {
    if (!brochure) return;

    const link = document.createElement("a");
    link.href = `${apiUrl.apiUrl}/${brochure}`; // use the prop
    link.setAttribute("download", "brochure.pdf");
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const logoresponse = await fetch(apiUrl.apiUrl + `/api/logos/section`);
        if (!logoresponse.ok) throw new Error("Failed to fetch logo data");
        const logodata = await logoresponse.json();

        const logoPathMap = {
          "": "",
          "/properties/marquis-horizon": "Marquis Horizon",
          "/properties/marquis-one": "Marquis One",
          "/properties/marquis-vista": "Marquis Vista",
          "/properties/marquis-insignia": "Marquis Insignia",
          "/properties/marquis-elegance": "Marquis Elegance",
          "/properties/marquis-galleria": "Marquis Galleria",
          "/properties/marquis-signature": "Marquis Signature",
          "/properties/2020-marquis": "2020 Marquis",
        };
        const pageTitle = logoPathMap[location.pathname] || "Header Logo";
        const selectedLogo = logodata.find(
          (logo) => logo.logo_title === pageTitle,
        );
        setaboutLogo(selectedLogo);
      } catch (error) {
        console.error("Error fetching logo data:", error);
      }
    };
    fetchLogos();
  }, [location.pathname]);

  return (
    <Fragment>
      <section className="collection-inner-page-about-sec">
        <Container fluid>
          <Row className="banner-text-center">
            <Col md={6}>
              <div className="heading-div">
                {aboutLogo && (
                  <img
                    src={apiUrl.apiUrl + `/${aboutLogo.logo}`}
                    className="img-fluid collection-logo" data-aos="fade-up"
                  />
                )}
                <h1 className="common-head darkGrey" data-aos="fade-up">
                  {title}
                </h1>                
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid className="collection-inner-page-about-container">
          <Row>
            <Col md={6}>
              {/* <LazyLoad> */}
              <img
                src={`${apiUrl.apiUrl}/${leftImage}`}
                className="img-fluid"
                alt={title}
                data-aos="fade-down"
              />
              {/* </LazyLoad> */}
            </Col>
            <Col md={6}>
              {/* <LazyLoad> */}
              <img
                src={`${apiUrl.apiUrl}/${rightImage}`}
                className="img-fluid col-new-img"
                alt="Apartments for sale in Dubai"
                data-aos="fade-down"
              />
              {/* </LazyLoad> */}
              <div className="content-div">
                <h2 className="common-head goldenColor">{subTitle}</h2>
                <p className="common-para">{description}</p>
                <div
                  onClick={handleShowbrochure}
                  className="marquis-grey-button"
                >
                  Download brochure
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Enquiry Button Modal */}
      <div>
        {/* Enquiry Button Modal */}
        <Modal
          show={show}
          onHide={handleClosebrochure}
          centered
          size="lg"
          className="download-brochure-modal"
        >
          <Modal.Header closeButton></Modal.Header>

          <Modal.Body>
            <div className="enquiry-form-modal-div">
              <Container fluid>
                <Row className="flex-center career-inner-desc-row">
                  <Col md={12}>
                    <div className="career-inner-form-div">
                      <h2 className="common-head goldenColor">
                        Download Brochure
                      </h2>
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Form.Group
                            className="col-md-12 mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Control
                              type="text"
                              name="name"
                              placeholder="Your Name *"
                              value={formData.name}
                              onChange={handleNameChange}
                              onBlur={handleBlur}
                            />

                            {errors.name && (
                              <p className="error">{errors.name}</p>
                            )}
                          </Form.Group>
                          <Form.Group
                            className="col-md-12 mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Control
                              type="text"
                              name="email"
                              placeholder="Email"
                              value={formData.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.email && (
                              <p className="error">{errors.email}</p>
                            )}
                          </Form.Group>
                        </Row>
                        <Row>
                          <Form.Group
                            className="col-md-12 mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <div style={{ display: "flex" }}>
                              <CountryCodeField
                                countryCode={formData.countryCode}
                                onManualSelect={handleCountryCodeSelect}
                                onBlur={handleBlur}
                                permissionGranted={permissionGranted}
                              />
                              <Form.Control
                                type="text"
                                onPaste={handlePaste}
                                name="mobile"
                                placeholder="Your Phone Number *"
                                value={formData.mobile}
                                onChange={handleMobileChange}
                                onBlur={handleBlur}
                              />
                            </div>

                            <div style={{ display: "flex" }}>
                              {errors.countryCode && (
                                <p className="error">{errors.countryCode}</p>
                              )}

                              {errors.mobile && (
                                <p className="error">{errors.mobile}</p>
                              )}
                            </div>
                          </Form.Group>
                        </Row>
                        <Row>
                          <Form.Group className="col-md-12 mb-3">
                            <ReCAPTCHA
                              className="gcaptcha-size"
                              sitekey="6LeGM28qAAAAAGmZjltF8c4tuHV9F9vxFdjtKPoC"
                              ref={captchaRef}
                              onChange={(value) => {
                                setFormData((prevData) => ({
                                  ...prevData,
                                  captchaToken: value,
                                }));
                                validateField("captchaToken", value);
                              }}
                            />

                            {errors.captchaToken && (
                              <p className="error gcaptcha-error-msg">
                                {errors.captchaToken}
                              </p>
                            )}
                          </Form.Group>
                        </Row>

                        <Row className="mt-2 form-btn">
                          <Col md={12}>
                            <button
                              type="submit"
                              className="marquis-grey-button"
                            >
                              Submit
                            </button>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                    <Row className="mt-2 form-btn">
                      <Col md={12}>
                        <div className="enquiry-form-bottom-logo">
                          <img
                            className="img-fluid"
                            src={marquisLogo}
                            alt="marquislogo-img"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </div>
          </Modal.Body>
        </Modal>
      </div>

      {/* Modal Component */}
      <Modal
        show={showThankYouModal}
        onHide={handleCloseThankYouModal}
        className="response-popup"
      >
        <Modal.Header>
          <Modal.Title>Thank You!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{thankYouMessage}</Modal.Body>
        <Modal.Footer>
          <button
            className="marquis-grey-button"
            onClick={handleCloseThankYouModal}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}

export default CollectionInnerAbout;
